<template>
  <span class="scaling-svg-container">
    <svg
      class="scaling-svg"
      data-name="Icon/Arrow Ios Down"
      xmlns="http://www.w3.org/2000/svg"
      width="14.375"
      height="7.187"
      viewBox="0 0 14.375 7.187"
    >
      <path
        data-name="Icon/Icon/Arrow-ios-down"
        d="M7.188,7.187a1.02,1.02,0,0,1-.657-.238L.37,1.815A1.027,1.027,0,1,1,1.684.238L7.2,4.834,12.705.4A1.027,1.027,0,0,1,13.993,2L7.832,6.96a1.027,1.027,0,0,1-.644.227"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ArrowDownIcon extends Vue {}
</script>

<style>
</style>
